import {
  BTCLogo,
  ETHLogo,
  JSTLogo,
  NFTLogo,
  SafeMoneyLogo,
  SUNLogo,
  TRXLogo,
  TUSDLogo,
  USDCLogo,
  USDJLogo,
  WBTTLogo,
  WINLogo,
  RickLogo,
  PnLogo,
  BtzcLogo,
  NdwLogo,
  AcvtLogo,
  DiceLogo,
  LiveLogo,
  USDTLogo,
  TFanLogo,
  SunOldLogo,
  UsddLogo,
} from '../assets/icons/tokens';
import { TypeToken } from '../types';

import { isProduction } from './index';

export const tokenList: TypeToken[] = isProduction
  ? [
      {
        name: 'TRX',
        symbol: 'TRX',
        address: '',
        decimals: 6,
        logo: TRXLogo,
      },
      {
        name: 'SafeMoney',
        symbol: 'SM',
        address: 'TNBrVEzuVYbNbGF2ua3ivSX5Y5V9N4xhax',
        decimals: 8,
        logo: SafeMoneyLogo,
      },
      {
        name: 'Bitcoin',
        symbol: 'BTC',
        address: 'TN3W4H6rK2ce4vX9YnFQHwKENnHjoxb3m9',
        decimals: 8,
        logo: BTCLogo,
      },
      {
        name: 'Ethereum',
        symbol: 'ETH',
        address: 'THb4CqiFdwNHsWsQCs4JhzwjMWys4aqCbF',
        decimals: 18,
        logo: ETHLogo,
      },
      {
        name: 'Tether USD (USDT)',
        symbol: 'USDT',
        address: 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t',
        decimals: 6,
        logo: USDTLogo,
      },
      {
        name: 'Decentralized USD',
        symbol: 'USDD',
        address: 'TPYmHEhy5n8TCEfYGqW2rPxsghSfzghPDn',
        decimals: 18,
        logo: UsddLogo,
      },
      {
        name: 'SUN TOKEN',
        symbol: 'SUN',
        address: 'TSSMHYeV2uE9qYH95DqyoCuNCzEL1NvU3S',
        decimals: 18,
        logo: SUNLogo,
      },
      {
        name: 'SunOld',
        symbol: 'SUNOLD',
        address: 'TKkeiboTkxXKJpbmVFbv4a8ov5rAfRDMf9',
        decimals: 18,
        logo: SunOldLogo,
      },
      {
        name: 'WINK',
        symbol: 'WIN',
        address: 'TLa2f6VPqDgRE67v1736s7bJ8Ray5wYjU7',
        decimals: 6,
        logo: WINLogo,
      },
      {
        name: 'APENFT',
        symbol: 'NFT',
        address: 'TFczxzPhnThNSqr5by8tvxsdCFRRz6cPNq',
        decimals: 6,
        logo: NFTLogo,
      },
      {
        name: 'USD Coin',
        symbol: 'USDC',
        address: 'TEkxiTehnzSmSe2XqrBj4w32RUN966rdz8',
        decimals: 6,
        logo: USDCLogo,
      },
      {
        name: 'Wrapped BitTorrent',
        symbol: 'WBTT',
        address: 'TKfjV9RNKJJCqPvBtK8L7Knykh7DNWvnYt',
        decimals: 6,
        logo: WBTTLogo,
      },
      {
        name: 'BTT New',
        symbol: 'BTT',
        address: 'TAFjULxiVgT4qWk6UZwjqwZXTSaGaqnVp4',
        decimals: 18,
        logo: WBTTLogo,
      },
      {
        name: 'JUST GOV v1.0',
        symbol: 'JST',
        address: 'TCFLL5dx5ZJdKnWuesXxi1VPwjLVmWZZy9',
        decimals: 18,
        logo: JSTLogo,
      },
      {
        name: 'JUST Stablecoin v1.0',
        symbol: 'USDJ',
        address: 'TMwFHYXLJaRUPeW6421aqXL4ZEzPRFGkGT',
        decimals: 18,
        logo: USDJLogo,
      },
      {
        name: 'TrueUSD',
        symbol: 'TUSD',
        address: 'TUpMhErZL2fhh4sVNULAbNKLokS4GjC1F4',
        decimals: 18,
        logo: TUSDLogo,
      },
      {
        name: 'Infinite Ricks',
        symbol: 'RICK',
        address: 'TDk5875Key1Yu2TxWy5W5EogUP86r7Jhxd',
        decimals: 6,
        logo: RickLogo,
      },
      {
        name: 'NDW',
        symbol: 'NDW',
        address: 'TCdB7kBa2TFng6Kc57Uf6ai2psBGi5zyij',
        decimals: 6,
        logo: NdwLogo,
      },
      {
        name: 'BeatzCoin',
        symbol: 'BTZC',
        address: 'TNsnPquPbEo6zCYSB9mZbrnSogyJ3cksNo',
        decimals: 6,
        logo: BtzcLogo,
      },
      {
        name: 'PN',
        symbol: 'PN',
        address: 'TDxbHVxtpDoJJ5bnG6xJHc1ezJK5Zuuw2S',
        decimals: 6,
        logo: PnLogo,
      },
      {
        name: 'ActivEightCoin',
        symbol: 'ACTIV',
        address: 'TVoxBVmFuBM7dsRnfi1V8v1iupv4uyPifN',
        decimals: 8,
        logo: AcvtLogo,
      },
      {
        name: 'TRONbetDice',
        symbol: 'DICE',
        address: 'TKttnV3FSY1iEoAwB4N52WK2DxdV94KpSd',
        decimals: 6,
        logo: DiceLogo,
      },
      {
        name: 'TRONbetLive',
        symbol: 'LIVE',
        address: 'TVgAYofpQku5G4zenXnvxhbZxpzzrk8WVK',
        decimals: 6,
        logo: LiveLogo,
      },
      {
        name: 'FansForever (tFAN)',
        symbol: 'tFAN',
        address: 'TDkHstpm1Rv7CaNGKJgYwq8CeyaJY13Ag2',
        decimals: 6,
        logo: TFanLogo,
      },
    ]
  : [
      {
        name: 'TRX',
        symbol: 'TRX',
        address: '',
        decimals: 6,
        logo: TRXLogo,
      },
      {
        name: 'Solana',
        // symbol: 'SOL',
        symbol: 'BTC',
        // address: 'TMCtbHNYWavDHBPEcJvDij6uAUU3cHq5xJ',
        address: 'TR2LhjakHAJJjQ2pgC7MgZViGjbmqTxGtx',
        decimals: 8,
        logo: TRXLogo,
      },
      {
        name: 'Cardano',
        // symbol: 'ADA',
        symbol: 'ETH',
        // address: 'TSk6XgRK6k9Y9nwcLx3ZJXf4XA9eurtceK',
        address: 'TYz83rJyWnQfQzTKVPXzC1NLJJ4fhsVRFQ',
        decimals: 8,
        logo: TRXLogo,
      },
      {
        name: 'DOGE',
        // symbol: 'DOGE',
        symbol: 'TRX',
        // address: 'TDNSKtL8vSWeGPFGm9TymtJptqNcotBWHG',
        address: 'TSHhGarhroL8DnyYrBKRx6i68ZpdJhosmv',
        decimals: 8,
        logo: TRXLogo,
      },
    ];
